import {enableProdMode, inject, provideEnvironmentInitializer} from '@angular/core';
import localeCs from '@angular/common/locales/cs';
import localeSk from '@angular/common/locales/sk';
import {registerLocaleData} from '@angular/common';
import {CounterTypeGroup, MainMenuCountsService, provideAuthServices, provideEspisMainAppInitializers,} from '|shared';
import {bootstrapApplication} from '@angular/platform-browser';
import {APP_ROUTES} from './app/app.routes';
import {NavigationEnd, provideRouter, Router, withRouterConfig} from '@angular/router';
import {provideDocumentDialogManagers} from '|feature-documents';
import {provideEsslApiConfigurations} from './app/essl-api.providers';
import {provideApiDraftConfigurations} from '|api-draft/api-draft.providers';
import {enumValuesToArray, filterByClass} from '@icz/angular-application-core';
import {
  ActiveModuleService,
  AppComponent,
  Application,
  ApplicationRoute,
  AuthInterceptor,
  getApplicationModuleByUrl,
  MicroserviceApplication,
  provideEsslCore,
  WebSocketNotificationsService
} from '|ui-essl-core';
import {STATIC_ENVIRONMENT} from './environments/environment';
import {SavedFiltersService} from '@icz/angular-table';
import {InternalNotificationMessageCode} from '|api/commons';

if (STATIC_ENVIRONMENT.production) {
  enableProdMode();
}

registerLocaleData(localeCs);
registerLocaleData(localeSk);

bootstrapApplication(
  AppComponent,
  {
    providers: [
      provideEsslApiConfigurations(),
      provideApiDraftConfigurations(),
      provideEspisMainAppInitializers(),
      provideAuthServices(),
      provideDocumentDialogManagers(),
      provideEsslCore({
        application: Application.MAIN,
        additionalInterceptors: [
          AuthInterceptor,
        ],
        healthCheckedMicroservices: enumValuesToArray(MicroserviceApplication) as MicroserviceApplication[], // all
      }),
      provideEnvironmentInitializer(() => {
        const webSocketNotificationsService = inject(WebSocketNotificationsService);
        const mainMenuCountsService = inject(MainMenuCountsService);
        const activeModuleService = inject(ActiveModuleService);
        const router = inject(Router);

        webSocketNotificationsService.getMessageListener$(
          InternalNotificationMessageCode.BULK_REGISTRY_OFFICE_UPDATE_CREATE_SUCCESS
        ).subscribe(() => {
          mainMenuCountsService.updateMainMenuCounters([
            CounterTypeGroup.DOCUMENT_FILE_TASKS_RECEIVED_CONSIGNMENTS_TRANSFERS_COUNTS
          ]);
        });

        router.events.pipe(
          filterByClass(NavigationEnd),
        ).subscribe(event => {
          if (
            !event.url.includes(ApplicationRoute.WAITING_TO_BE) &&
            !event.url.includes(ApplicationRoute.APPLICATION_UNAVAILABLE)
          ) {
            activeModuleService.activeModule = getApplicationModuleByUrl(event.url);
          }
        });

        // Keep this inject of SavedFiltersService here, otherwise PopupSelector will stop working due to cyclic dep error.
        inject(SavedFiltersService);
      }),
      provideRouter(
        APP_ROUTES,
        withRouterConfig({ onSameUrlNavigation: 'reload' })
      )
    ]
  }
).catch(
  // eslint-disable-next-line no-console
  err => console.error(err)
);
